export default __webpack_public_path__ + "static/dogberry-day-1-3dc30b0ee6ecaba7d7266797b2563914.png";